import { render, staticRenderFns } from "./door.vue?vue&type=template&id=3db37b9f&"
import script from "./door.vue?vue&type=script&lang=ts&"
export * from "./door.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports